<!-- Intestazione e documento sono figli DIRETTI della superficie (niente <div>
     di raggruppamento): la veste .izy-viewer-dialog-panel fa della superficie
     un flex column alto quanto il pannello, ed e' cosi' che l'intestazione
     resta in cima e il documento si prende tutto lo spazio che avanza. -->
<header class="izy-viewer-header">
  <h2 class="izy-viewer-title">
    <mat-icon>picture_as_pdf</mat-icon>
    <span>Anteprima documento</span>
  </h2>

  <!-- L'unica azione del dialog e' chiudere, quindi sta qui accanto al titolo
       e non in una fascia delle azioni tutta per se'. Prima era una "×"
       scritta a mano in un <button> nudo: ora e' il pulsante icona di
       Material, che porta con se' area di click e nome accessibile. -->
  <button
    mat-icon-button
    type="button"
    (click)="closeDialog()"
    aria-label="Chiudi anteprima"
    class="izy-viewer-close">
    <mat-icon>close</mat-icon>
  </button>
</header>

<div class="izy-viewer-body">
  <iframe [src]="pdfUrl" title="Anteprima del documento" frameborder="0"></iframe>
</div>
